import React from 'react';
import { DateRangeInput, DateRangeInputProps, Flex, Text } from 'pounceV2';
import { CompoundInputChildElementProps } from '../CompoundInputV3';

export type CompoundDateRangeInputProps = Omit<
  CompoundInputChildElementProps,
  'value' | 'onChange'
> &
  Omit<DateRangeInputProps, 'value' | 'onChange' | 'labelStart' | 'labelEnd' | 'renderInput'> & {
    valueStart?: string | null;
    valueEnd?: string | null;
    labelStart?: string;
    labelEnd?: string;
    onChange: (date: [string, string] | null) => void;
  };

const CompoundDateRangeInputV3 = React.forwardRef<HTMLInputElement, CompoundDateRangeInputProps>(
  function CompoundDateRangeInput(
    {
      valueStart,
      labelStart = '',
      labelEnd = '',
      valueEnd,
      onKeyDown,
      format,
      timezone,
      ...rest
    }: CompoundDateRangeInputProps,
    ref,
  ) {
    const timezoneLabels: Record<string, string> = { utc: 'UTC', local: 'Local' };
    const timezoneLabel = timezoneLabels[timezone];

    const value: [Date?, Date?] = [
      valueStart ? new Date(valueStart) : undefined,
      valueEnd ? new Date(valueEnd) : undefined,
    ];

    return (
      <Flex align="center" gap={1}>
        <DateRangeInput
          {...rest}
          format={format}
          timezone={timezone}
          labelStart={labelStart}
          labelEnd={labelEnd}
          value={value}
          onChange={dates =>
            rest.onChange(
              dates?.[0] && dates?.[1] ? [dates[0].toISOString(), dates[1].toISOString()] : null,
            )
          }
          slotProps={{
            textField: {
              hiddenLabel: true,
              inputRef: ref,
              inputProps: { onKeyDown },
              sx: {
                '& fieldset': { border: 'none' },
                '& .Mui-focused fieldset': { border: 'none !important' },
                '& .MuiPickersSectionList-root': { padding: '7px 0px 7px' },
                '& .MuiInputBase-root': {
                  backgroundColor: 'transparent',
                  fontSize: 'inherit',
                  color: 'inherit',
                },
                '& .MuiInputBase-input': {
                  padding: '0 4px 0 0',
                  color: 'inherit',
                  fontSize: 'inherit',
                },
              },
            },
          }}
        />
        {timezoneLabel && (
          <Text fontSize="inherit" color="inherit">
            ({timezoneLabel})
          </Text>
        )}
      </Flex>
    );
  },
);

export default CompoundDateRangeInputV3;
